import { alpha, useTheme } from "@mui/material";
import { InfoProps } from "../../types";

export const HInfo = (props: InfoProps) => {
  const { palette } = useTheme();
  const {
    size = 20,
    background = alpha(palette.primary.dark, 0.2),
    iconColor = palette.primary.dark,
  } = props;
  return (
    <svg
      data-testid="HinfoIcon"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        transform={`scale(${size / 20})`}
        d="M0,10a10,10 0 1,0 20,0a10,10 0 1,0 -20,0"
        fill={background}
      />
      <path
        transform={`scale(${size / 20})`}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M 10.8 14.137 C 10.8 14.521 10.442 14.832 10 14.832 C 9.558 14.832 9.2 14.521 9.2 14.137 L 9.2 8.927 C 9.2 8.543 9.558 8.232 10 8.232 C 10.442 8.232 10.8 8.543 10.8 8.927 L 10.8 14.137 Z M 10.8 6.032 C 10.8 6.474 10.442 6.832 10 6.832 C 9.558 6.832 9.2 6.474 9.2 6.032 L 9.2 5.032 C 9.2 4.59 9.558 4.232 10 4.232 C 10.442 4.232 10.8 4.59 10.8 5.032 L 10.8 6.032 Z"
        fill={iconColor}
      />
    </svg>
  );
};
